import { MtGroup } from "server/models"
import { OrderType } from "client/utils"


export interface GroupProps {
    groupId: number
}
export type GroupValidation = { [key in keyof MtGroup]?: string}

export interface GroupList { [groupId: number]: MtGroup }
export interface GroupFilters {
    search?: string
}

export interface GroupState {
    groupList: GroupList
    groupIds: readonly number[]
    groupView: MtGroup
    groupEdit: MtGroup

    accountGroups: GroupList // used only in "pages/mt/userGroups"

    sortColumn: keyof MtGroup
    sortOrder: OrderType
    filters: GroupFilters

    reloadList: boolean
    reloadView: boolean
    reloadEdit: boolean
}

export const GROUP_LIST = "GROUP_LIST"
export const GROUP_IDS = "GROUP_IDS"
export const GROUP_VIEW = "GROUP_VIEW"
export const GROUP_EDIT = "GROUP_EDIT"

export const ACCOUNT_GROUPS = "ACCOUNT_GROUPS"

export const GROUP_SORT = "GROUP_SORT"
export const GROUP_FILTERS = "GROUP_FILTERS"

export const GROUP_RELOAD_LIST = "GROUP_RELOAD_LIST"
export const GROUP_RELOAD_VIEW = "GROUP_RELOAD_VIEW"
export const GROUP_RELOAD_EDIT = "GROUP_RELOAD_EDIT"
